// src/hooks/useNotificationModal.js
import { useState, useEffect, useCallback } from 'react';
import SystemNotificationService from '../Services/system-notification.service';
import { Refresh } from '@mui/icons-material';

const sortFeed = list =>
    [...list].sort((a, b) => {
        if (a.isRead !== b.isRead) return a.isRead ? 1 : -1; // unread first
        return new Date(b.startAt) - new Date(a.startAt);     // newest first
    });

export default function useNotificationModal(getUserState) {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);

    /* ────────── fetch once (or on demand) ────────── */
    const fetchFeed = useCallback(async () => {
        setLoading(true);
        try {
            const { userId, userType } = getUserState();
            if (!userId || !userType) {
                setLoading(false);
                return;
            }
            const feed = await SystemNotificationService.user.feed({ userId, userType: +userType });
            setNotifications(sortFeed(feed));
            if (feed.some(n => !n.isRead)) setVisible(true); // auto-open
        } catch (e) {
            console.error('[notifications] fetch failed:', e.message);
        } finally {
            setLoading(false);
        }
    }, [getUserState]);

    useEffect(() => { fetchFeed(); }, [fetchFeed]);

    /* mark one as read – local only */
    const markLocalRead = id =>
        setNotifications(curr => sortFeed(
            curr.map(n => (n.id === id ? { ...n, isRead: true } : n))
        ));

    const unreadCount = notifications.filter(n => !n.isRead).length;

    return {
        notifications,
        loading,
        unreadCount,
        visible,
        open: () => setVisible(true),
        close: () => setVisible(false),
        markLocalRead,
        refresh: fetchFeed,
    };
}
